<template>
  <div>
    <header-component position-relation></header-component>
    <div class="body-max-container">
      <div class="login-container">
        <div class="box selector-box" :class="{ inactive: !activeSelector }">
          <div class="selector-body">
            <el-button
              type="text"
              class="btn-box go-login-btn"
              @click="handleStepBox('LoginBox')"
            >會員登入</el-button>
            <el-button
              type="text"
              class="btn-box go-register-btn"
              @click="handleStepBox('RegisterBox')"
            >註冊成為會員</el-button>
          </div>
        </div>
        <div class="box login-box" :class="{ inactive: !activeLogin }">
          <div class="login-body">
            <h3 class="title">會員登入</h3>
            <el-input v-model="loginMemberModel.username" placeholder="輸入email"></el-input>
            <el-input v-model="loginMemberModel.password" placeholder="輸入密碼"></el-input>
            <el-button type="text" class="forgot-password" @click="handleStepBox('ForgetPasswordBox')">找回密碼</el-button>
          </div>
          <div class="enter-btn" @click="handleLogin">
            <img src="../assets/img/icon-arrow-right.svg" alt />
          </div>
        </div>
        <div class="box register-box" :class="{ inactive: !activeRegister }">
          <div class="register-body">
            <h3 class="title">會員註冊</h3>
            <h4 class="sub-title">
              還沒加入會員？<br />
              歡迎註冊和關心動物互動，下載更多教案、圖文素材。
            </h4>
            <div class="register-content" v-if="openRegister">
              <h3 class="title">帳號</h3>
              <el-input v-model="registerMemberModel.nickName" placeholder="暱稱"></el-input>
              <el-col :span="12">
                <el-input v-model="registerMemberModel.firstName" placeholder="姓"></el-input>
              </el-col>
              <el-col :span="12">
                <el-input v-model="registerMemberModel.lastName" placeholder="名"></el-input>
              </el-col>
              <el-input v-model="registerMemberModel.password" placeholder="密碼"></el-input>
              <el-input v-model="registerMemberModel.email" placeholder="email"></el-input>
              <h3 class="title">身份</h3>
              <el-row class="option-row">
                <el-col :span="8">
                  <div class="option-col" :class="{ active: registerMemberModel.role === '學生' }" @click="() => { registerMemberModel.role = '學生' }">
                    <span>學生</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="option-col" :class="{ active: registerMemberModel.role === '在職' }" @click="() => { registerMemberModel.role = '在職' }">
                    <span>在職</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="option-col" :class="{ active: registerMemberModel.role === '其他' }" @click="() => { registerMemberModel.role = '其他' }">
                    <span>其他</span>
                  </div>
                </el-col>
              </el-row>
              <h3 class="title">生理性別</h3>
              <el-row class="option-row">
                <el-col :span="8">
                  <div class="option-col" :class="{ active: registerMemberModel.sex === '女性' }" @click="() => { registerMemberModel.sex = '女性' }">
                    <span>女性</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="option-col" :class="{ active: registerMemberModel.sex === '男性' }" @click="() => { registerMemberModel.sex = '男性' }">
                    <span>男性</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="option-col" :class="{ active: registerMemberModel.sex === '其他' }" @click="() => { registerMemberModel.sex = '其他' }">
                    <span>其他</span>
                  </div>
                </el-col>
              </el-row>
              <h3 class="title">生日</h3>
              <el-row class="option-row">
                <el-col :span="8">
                  <div class="option-col">
                    <el-select
                      v-model="registerMemberModel.birthdayYear"
                      class="option-select"
                      placeholder="年"
                    >
                      <el-option
                        v-for="item in getDateYear"
                        :key="`Year_${item}`"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="option-col">
                    <el-select
                      v-model="registerMemberModel.birthdayMonth"
                      class="option-select"
                      placeholder="月"
                      :disabled="!isEnableMonth"
                    >
                      <el-option
                        v-for="item in getDateMonth"
                        :key="`Month_${item}`"
                        :label="item + 1"
                        :value="item"
                      />
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="option-col">
                    <el-select
                      v-model="registerMemberModel.birthdayDay"
                      class="option-select"
                      placeholder="日"
                      :disabled="!isEnableDay"
                    >
                      <el-option
                        v-for="item in getDateDay"
                        :key="`Day_${item}`"
                        :label="item + 1"
                        :value="item"
                      />
                    </el-select>
                  </div>
                </el-col>
              </el-row>
              <el-row class="option-row">
                <el-button class="register-btn" @click="handleRegister">註冊</el-button>
              </el-row>
            </div>
          </div>
          <div v-if="!openRegister" class="enter-btn">
            <img src="../assets/img/icon-arrow-right.svg" alt @click="openRegister = true" />
          </div>
        </div>
        <div class="box forget-password-box" :class="{ inactive: !activeForgetPassword }">
          <div class="forget-password-body">
            <h3 class="title">找回密碼</h3>
            <el-input v-model="forgetPapaModel.email" placeholder="輸入註冊e-mail"></el-input>
          </div>
          <div class="enter-btn" @click="handleForgotPassword()">
            <img src="../assets/img/icon-arrow-right.svg" style="top: 73px" alt />
          </div>
        </div>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import FooterComponent from "../components/FooterComponent";
import { DeviceTypeEnum } from "@/utils/enum";
import { MemberModel } from "@/models/member-model";
import { login, register, forgotPassword } from "@/apis/member";
import { ResponseModel } from "@/models/response-model";

export default {
  name: "Login",
  components: { FooterComponent, HeaderComponent },
  computed: {
    getDateYear() {
      const nowYear = new Date().getFullYear();
      const years = [];
      for (let i = 0; i < 100; i++) {
        years.push(nowYear - i);
      }
      return years;
    },
    isEnableMonth() {
      return !isNaN(this.registerMemberModel.birthdayYear);
    },
    getDateMonth() {
      const months = [];
      if (this.isEnableMonth) {
        for (let i = 0; i <= 11; i++) {
          months.push(i);
        }
      }
      return months;
    },
    isEnableDay() {
      return !isNaN(this.registerMemberModel.birthdayMonth);
    },
    isLeap() {
      const year = this.registerMemberModel.birthdayYear;
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    },
    getDateDay() {
      const days = [];
      let dayCount = 0;
      if (this.isEnableDay && this.registerMemberModel.birthdayMonth !== 1) {
        dayCount =
          new Date(
            this.registerMemberModel.birthdayYear,
            this.registerMemberModel.birthdayMonth,
            0
          ).getDate() + 1;
      } else if (this.registerMemberModel.birthdayMonth === 1) {
        dayCount = this.isLeap ? 29 : 28;
      }
      for (let i = 0; i < dayCount; i++) {
        days.push(i);
      }
      return days;
    },
  },
  data() {
    return {
      activeSelector: false,
      activeLogin: false,
      activeRegister: false,
      openRegister: false,
      activeForgetPassword: false,
      loginMemberModel: new MemberModel(),
      registerMemberModel: new MemberModel(),
      forgetPapaModel: {
        email: undefined,
        // username: undefined
      }
    };
  },
  created() {
    this.activeSelector = (this.$store.getters.device === DeviceTypeEnum.MOBILE)
    this.openRegister = (this.$store.getters.device === DeviceTypeEnum.MOBILE)
    this.activeLogin = (this.$store.getters.device !== DeviceTypeEnum.MOBILE)
    this.activeRegister = (this.$store.getters.device !== DeviceTypeEnum.MOBILE)
    // this.activeForgetPassword = (this.$store.getters.device !== DeviceTypeEnum.MOBILE)
    window.scroll(0, 0)
    this.$store.dispatch("member/logout")
  },
  methods: {
    handleStepBox(type) {
      switch (type) {
        case "SelectorBox":
          this.activeSelector = true
          this.openRegister = true
          this.activeLogin = false
          this.activeRegister = false
          this.activeForgetPassword = false
          break;
        case "LoginBox":
          this.activeSelector = false
          this.openRegister = false
          this.activeLogin = true
          this.activeRegister = false
          this.activeForgetPassword = false
          break;
        case "RegisterBox":
          this.activeSelector = false
          this.openRegister = true
          this.activeLogin = false
          this.activeRegister = true
          this.activeForgetPassword = false
          break;
        case "ForgetPasswordBox":
          this.activeSelector = false
          this.activeLogin = false
          this.activeRegister = false
          this.activeForgetPassword = true
          break;
        default:
          this.activeSelector = true
          this.openRegister = true
          this.activeLogin = false
          this.activeRegister = false
          this.activeForgetPassword = false
      }
    },
    handleLogin() {
      if (this.loginMemberModel.username && this.loginMemberModel.username.trim().length > 0 &&
        this.loginMemberModel.password && this.loginMemberModel.password.trim().length > 0) {
        login(this.loginMemberModel.username, this.loginMemberModel.password).then(res => {
          const response = new ResponseModel(res)
          if (response.isSuccess && response.result.token) {
            this.$store.dispatch("member/login", response.result.token)
            this.$12nightsAlert({
              title: "提示",
              message: "登入成功"
            }).then(() => {
              this.$router.push({
                name: "Home"
              });
            })
          } else {
            this.$12nightsAlert({
              title: "提示",
              message: "登入失敗，請輸入正確的帳號密碼"
            }).then(() => {
            })
          }
        })
      } else {
        this.$12nightsAlert({
          title: "提醒",
          message: "請輸入完整帳號密碼"
        }).then(() => {
        })
      }
    },
    handleRegister() {
      console.log(this.registerMemberModel)
      if (this.registerMemberModel.email && this.registerMemberModel.email.trim().length > 0 &&
        this.registerMemberModel.password && this.registerMemberModel.password.trim().length > 0 &&
        this.registerMemberModel.firstName && this.registerMemberModel.firstName.trim().length > 0 &&
        this.registerMemberModel.lastName && this.registerMemberModel.lastName.trim().length > 0 &&
        this.registerMemberModel.nickName && this.registerMemberModel.nickName.trim().length > 0 &&
        this.registerMemberModel.role && this.registerMemberModel.role.trim().length > 0 &&
        this.registerMemberModel.sex && this.registerMemberModel.sex.trim().length > 0 &&
        this.registerMemberModel.birthdayYear && this.registerMemberModel.birthdayYear > 0 &&
        this.registerMemberModel.birthdayMonth && this.registerMemberModel.birthdayMonth > 0 &&
        this.registerMemberModel.birthdayDay && this.registerMemberModel.birthdayDay > 0
      ) {
        register(this.registerMemberModel.registerJson).then(res => {
          const response = new ResponseModel(res)
          if (response.isSuccess) {
            this.$12nightsAlert({
              title: "提示",
              message: "註冊成功，請重新登入"
            }).then(() => {
              this.registerMemberModel = new MemberModel()
            })
          } else {
            this.$12nightsAlert({
              title: "註冊失敗",
              message: response.message
            }).then(() => {
            })
          }
        }).catch()
      } else {
        this.$12nightsAlert({
          title: "提醒",
          message: "請輸入完整註冊資料"
        }).then(() => {
        })
      }
    },
    handleForgotPassword() {
      if (this.forgetPapaModel.email && this.forgetPapaModel.email.trim().length > 0) {
        this.l
        forgotPassword(this.forgetPapaModel.email).then(res => {
          const response = new ResponseModel(res)
          if (response.isSuccess) {
            this.$12nightsAlert({
              title: "提示",
              message: "新密碼已發送至您的信箱，謝謝！"
            }).then(() => {
              this.$router.push({
                name: "Home"
              });
            })
          } else {
            this.$12nightsAlert({
              title: "提示",
              message: response.message
            }).then(() => {
            })
          }
        })
      } else {
        this.$12nightsAlert({
          title: "提醒",
          message: "請輸入完整的Email"
        }).then(() => {
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
.option-select {
  .el-input {
    margin-top: 0;
  }
  .el-input .el-input__inner {
    border: 0;
    border-radius: 5px;
    text-align: center;
  }
}
</style>
